<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <div :class="$style.header">
        <Title :title-params="primary.medias_title" :class="$style.title" />
        <RichText
          :text-params="primary.medias_subtitle"
          :class="$style.subtitle"
        />
      </div>
      <VueSlickCarousel
        ref="lgCarousel"
        v-bind="lgSlickOptions"
        :class="$style.lgCarousel"
        @init="initCarousel"
        @beforeChange="beforeChange"
      >
        <div v-for="(item, itemIndex) in items" :key="itemIndex">
          <div :class="$style.cardContainer">
            <transition name="fade">
              <CarouselArrow
                v-if="isActive(itemIndex)"
                direction="Left"
                @go="go('left')"
              />
            </transition>

            <MediaCard
              :item="item"
              :class="[{ [$style.nonActiveSlide]: !isActive(itemIndex) }]"
            />

            <transition name="fade">
              <CarouselArrow
                v-if="isActive(itemIndex)"
                direction="Right"
                @go="go('right')"
              />
            </transition>
          </div>
        </div>
      </VueSlickCarousel>

      <div :class="$style.mdCarousel">
        <VueSlickCarousel ref="mdCarousel" v-bind="mdSlickOptions">
          <div v-for="(item, itemIndex) in items" :key="itemIndex">
            <div :class="$style.cardContainer">
              <MediaCard :item="item" />
            </div>
          </div>
        </VueSlickCarousel>
        <div :class="$style.mdArrowsContainer">
          <CarouselArrow
            direction="Left"
            is-big
            :class="$style.mdArrow"
            @go="moveMd('left')"
          />
          <CarouselArrow
            direction="Right"
            is-big
            :class="$style.mdArrow"
            @go="moveMd('right')"
          />
        </div>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

import Title from '~/components/Title'
import RichText from '~/components/RichText'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import CarouselArrow from './components/CarouselArrow'
import MediaCard from './components/MediaCard'

export default {
  name: 'Medias',

  components: {
    Title,
    RichText,
    VueSlickCarousel,
    CarouselArrow,
    MediaCard,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
      activeSlide: 0,
      lgSlickOptions: {
        arrows: false,
        centerMode: true,
        centerPadding: '23%',
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
      },
      mdSlickOptions: {
        arrows: false,
        centerMode: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
      },
    }
  },

  methods: {
    beforeChange(oldIndex, newIndex) {
      this.activeSlide = newIndex
    },
    initCarousel() {
      this.activeSlide = 0
    },
    go(direction) {
      if (direction === 'left') this.$refs.lgCarousel.prev()
      else this.$refs.lgCarousel.next()
    },
    isActive(index) {
      return this.activeSlide === index
    },
    moveMd(direction) {
      if (direction === 'left') this.$refs.mdCarousel.prev()
      else this.$refs.mdCarousel.next()
    },
  },
}
</script>

<style lang="scss" module>
.container {
  color: white;

  background-color: $bluko-800;
}
.inner {
  position: relative;

  max-width: 1440px;
  padding: 80px 0;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    display: block;
    width: 80px;
    height: 100%;

    background: linear-gradient(90deg, #122182 0%, rgba(18, 33, 130, 0) 100%);

    content: '';
    @include below(large) {
      display: none;
    }
  }
  &::after {
    position: absolute;
    top: 0;
    right: 0;

    display: block;
    width: 80px;
    height: 100%;

    background: linear-gradient(270deg, #122182 0%, rgba(18, 33, 130, 0) 100%);

    content: '';
    @include below(large) {
      display: none;
    }
  }
}

.header {
  max-width: 720px;
  margin: 0 auto 48px;
  padding: 0 24px;
}
.title {
  font-weight: 200;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
}

.subtitle {
  @include typo-body;
  text-align: center;
}

.lgCarousel {
  @include below(large) {
    display: none !important;
  }
}
.mdCarousel {
  @include above(large) {
    display: none !important;
  }
}
.mdArrowsContainer {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.mdArrow {
  margin: 12px;
}

.cardContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nonActiveSlide {
  opacity: 0.3;
}
</style>
<style lang="scss" scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter-active {
  transition: all 0.8s ease-in-out 0.2s;
}
</style>
